module.exports = __webpack_public_path__ + "static/media/payProgreso.d85d6dd6.png";